import { render, staticRenderFns } from "./CtaButton.vue?vue&type=template&id=20d8a592&scoped=true&"
import script from "./CtaButton.vue?vue&type=script&lang=js&"
export * from "./CtaButton.vue?vue&type=script&lang=js&"
import style0 from "./CtaButton.vue?vue&type=style&index=0&id=20d8a592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d8a592",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
